import { ChassisAbilities } from '@components/arsenal/chassis/ChassisAbilities';
import { StatsDisplay } from '@components/arsenal/StatsDisplay';
import { ArsenalBack } from '@components/arsenal/ArsenalBack';
import { capitalize } from '@helpers/dotNotation';
import { useTranslation } from 'react-i18next';

interface ChassisInfoProps {
  chassis: string;
  onBack?: () => void;
}

export function ChassisHeader({ chassis }: { chassis: string }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Chassis' });

  return (
    <>
      <div className="h-48 border-b border-secondary pt-2 relative">
        <div className="absolute inset-0 grid-overlay" />
        <div className="absolute inset-0 bg-black/40" />
        <img className="h-full mx-auto relative blur-animation"
          src={`/img/chassis/${chassis}.avif`}
          alt={chassis}
        />
      </div>

      <div className="p-2 text-left">
        <p className="text-lg font-bold leading-tight text-red-500">{capitalize(chassis)}</p>
        <p className="text-gray-300 text-xs mt-2 italic">{t(`${capitalize(chassis)}.lore`)}</p>
      </div>
    </>
  );
}

export function ChassisInfo({ chassis, onBack }: ChassisInfoProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'ChassisInfo' });

  return (
    <>
      {onBack && (
        <ArsenalBack bg="chassis.avif" onClick={onBack} />
      )}

      <ChassisHeader chassis={chassis} />
      <StatsDisplay value={chassis} type="chassis" />

      <p className="px-2 mt-6 text-lg">{t('abilities')}</p>
      <ChassisAbilities chassis={chassis} />
    </>
  );
}